import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/about/block2-智能客服2.png")